// src/services/Api.js
import axios from 'axios'
import * as microsoftTeams from "@microsoft/teams-js";
import store from '../store';

import msalInstance, { accessTokenRequest} from './Auth'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});


// Add a request interceptor
instance.interceptors.request.use((config) => {
  const state = store.getState();
  const account = msalInstance.getActiveAccount();

  //make sure role cookie is attached
  config.withCredentials = true;

  return new Promise((resolve, reject) => {
    if (state.app.isMsTeamsApp) {
      var authTokenRequest = {
        successCallback: (token) => { 
            //console.log("Success: " + token); 
            config.headers.Authorization = `Bearer ${token}`; 
            resolve(config); 
        },
        failureCallback: (error) => { 
            //console.log("Failure: " + error); 
            reject(error); 
        },
      };
      microsoftTeams.authentication.getAuthToken((authTokenRequest));
    }
    else {
      accessTokenRequest.account = account;
      msalInstance.acquireTokenSilent(accessTokenRequest)
        .then(response => {
          if (!!response.accessToken) {
            config.headers.Authorization = `Bearer ${response.accessToken}`
            resolve(config)
          } else {
            // Do something with error of acquiring the token
            reject(response)
          }
        })
        .catch(error => {
          //document.write(error);
          console.log(error);
          if (error.name === "InteractionRequiredAuthError")
            msalInstance.acquireTokenRedirect(accessTokenRequest);
        })
    }
  })
}, (error) => {
  // Do something with error of the request
  return Promise.reject(error)
})
    
export default instance;


// WEBPACK FOOTER //
// ./src/services/Api.js